import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

export default function AddChannelDialog({
  open,
  onClose,
  addingChannel,
  addChannelError,
  newChannelName,
  setNewChannelName,
  newChannelProfileNumber,
  setNewChannelProfileNumber,
  handleAddChannel,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      <DialogTitle>New Channel</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label='Channel name'
          value={newChannelName}
          onChange={(e) => setNewChannelName(e.target.value)}
          error={!!addChannelError}
          helperText={addChannelError}
          margin='normal'
          disabled={addingChannel}
        />
        <TextField
          fullWidth
          type='number'
          inputProps={{ min: 1, step: 1 }}
          label='Profile number'
          value={newChannelProfileNumber}
          onChange={(e) => setNewChannelProfileNumber(e.target.value)}
          margin='normal'
          disabled={addingChannel}
          helperText='Must be unique and greater than 0'
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={addingChannel}>
          Cancel
        </Button>
        <Button
          onClick={handleAddChannel}
          variant='contained'
          disabled={
            addingChannel ||
            !newChannelName?.trim() ||
            !(parseInt(newChannelProfileNumber, 10) >= 1)
          }
        >
          {addingChannel ? 'Creating...' : 'Create and select'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
